import { Typography } from '@material-ui/core'
import React, { PropsWithChildren, useContext } from 'react'
import styled from 'styled-components'
import { Disclaimer as DisclaimerBase } from '../../../components/disclaimer/disclaimer'
import { html } from '../../../utils/htmlParser'
import { nonNull } from '../../../utils/nonNull'
import { NewsPageContext } from '../index'
import { DisclaimersFragment } from '@gql'

export const StyledNewsDisclaimerSymbol = styled(Typography)`
  vertical-align: middle;
  font-size: ${props => props.theme.typography.pxToRem(10)};
  font-weight: 500;
  padding-right: 3px;
`

export const StyledNewsDisclaimerBase = styled(DisclaimerBase)`
  & > p {
    display: inline;
  }
`
export const StyledNewsDisclaimerWrapper = styled(DisclaimerBase)`
  background: #f2f2f2;
  gap: 0;

  > div:first-child {
    background: #fff;
    padding-bottom: ${props => props.theme.typography.pxToRem(35)};
  }

  > div:nth-child(2) {
    padding-top: ${props => props.theme.typography.pxToRem(25)};
    padding-bottom: 0;
  }

  > div:nth-child(n+3) {
    padding-bottom: 0;
  }

  > div:last-child {
    padding-bottom: ${props => props.theme.typography.pxToRem(25)};
  }
`
export const StyledNewsDisclaimerTitle= styled(DisclaimerBase)`
  & > h5 {
    margin-left: ${props => props.theme.typography.pxToRem(20)};
  }
`

export type NewsDetailDisclaimerProps = {
  data: DisclaimersFragment[]
  general?: DisclaimersFragment[]
}

export const NewsDetailDisclaimers: React.FC<PropsWithChildren<NewsDetailDisclaimerProps>> = ({ data, general }) => {
  const { newsPageId } = useContext(NewsPageContext)

  return (
    <> 
      {(data || general) &&
      <StyledNewsDisclaimerWrapper>
        <StyledNewsDisclaimerTitle id={`disclaimer_block_${newsPageId}`} title>{'INFORMATION YOU SHOULD KNOW'}</StyledNewsDisclaimerTitle>
        {general && nonNull(general).map((item, index) => {
          if (item.__typename === 'customDisclaimers_default_Entry' || item.__typename === 'homeLoanDisclaimers_default_Entry' || item.__typename === 'personalloandisclaimers_default_Entry') {
            return (
              <StyledNewsDisclaimerBase key={index} textBlock>
                {item.disclaimerText && html(item.disclaimerText)}
              </StyledNewsDisclaimerBase>
            )
          }

          return null
        })}
        {data && nonNull(data).map((item, index) => {
          if (item.__typename === 'customDisclaimers_default_Entry' || item.__typename === 'homeLoanDisclaimers_default_Entry' || item.__typename === 'personalloandisclaimers_default_Entry') {
            return (
              <StyledNewsDisclaimerBase key={index} textBlock>
                <StyledNewsDisclaimerSymbol key={index}>
                  {index+1}
                </StyledNewsDisclaimerSymbol>
                {item.disclaimerText && html(item.disclaimerText)}
              </StyledNewsDisclaimerBase>
            )
          }
  
          return null
        })}
      </StyledNewsDisclaimerWrapper>
      }
    </> 
  )
}